/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module L4PolicyModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

/**
 * @desc Collection for L4PolicySet items.
 * @author Zhiqian Liu
 */
export class L4PolicySetCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            objectName: 'l4policyset',
            windowElement: 'l4-policy-set-modal',
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_('L4PolicySet');
    }
}

L4PolicySetCollection.ajsDependencies = [
    'L4PolicySet',
];
